"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CardInventoryOperationLog',
  data: function data() {
    return {
      searchForm: {
        batchNo: '',
        productName: '',
        channelType: '',
        timeRange: [],
        operatorName: ''
      },
      tableData: [],
      tableLoading: false,
      exportLoading: false,
      page: 1,
      limit: 10,
      total: 0
    };
  },
  mounted: function mounted() {
    this.loadTable();
  },
  methods: {
    handleSearch: function handleSearch() {
      this.page = 1;
      this.loadTable();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        batchNo: '',
        productName: '',
        channelType: '',
        timeRange: [],
        operatorName: ''
      };
      this.page = 1;
      this.loadTable();
    },
    loadTable: function loadTable() {
      var _this = this;
      this.tableLoading = true;
      storeApi.cardBatchLogPage(this.buildQueryParams(true)).then(function (res) {
        var data = res || {};
        _this.tableData = data.list || [];
        _this.total = data.total || 0;
      }).catch(function () {
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.tableLoading = false;
      });
    },
    buildQueryParams: function buildQueryParams(withPage) {
      var params = {
        batchNo: this.searchForm.batchNo || undefined,
        productName: this.searchForm.productName || undefined,
        channelType: this.searchForm.channelType || undefined,
        operatorName: this.searchForm.operatorName || undefined
      };
      var _ref = this.searchForm.timeRange || [],
        _ref2 = _slicedToArray(_ref, 2),
        startTime = _ref2[0],
        endTime = _ref2[1];
      if (startTime && endTime) {
        params.startTime = startTime;
        params.endTime = endTime;
      }
      if (withPage) {
        params.page = this.page;
        params.limit = this.limit;
      }
      return params;
    },
    handleExport: function handleExport() {
      var _this2 = this;
      this.exportLoading = true;
      storeApi.cardBatchLogExport(this.buildQueryParams(false)).then(function (res) {
        if (!res || !res.fileName) {
          _this2.$message.warning('未获取到导出文件');
          return;
        }
        toolUtils.downloadFile(res.fileName, '一卡通生成批次卡密操作日志.xlsx');
        _this2.$message.success('导出任务已生成');
      }).finally(function () {
        _this2.exportLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.loadTable();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.loadTable();
    }
  }
};